const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

function isValidDateOnly(year, month, day) {
    if (month < 1 || month > 12 || day < 1) {
        return false;
    }

    const leapYear = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    const daysInMonth = [31, leapYear ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    return day <= daysInMonth[month - 1];
}

export function formatReportingDate(value) {
    if (typeof value !== "string") {
        return null;
    }

    const match = DATE_ONLY_PATTERN.exec(value);
    if (!match) {
        return null;
    }

    const [, year, monthText, dayText] = match;
    const month = Number(monthText);
    const day = Number(dayText);
    if (!isValidDateOnly(Number(year), month, day)) {
        return null;
    }

    return `${day}.${month}.${year}`;
}

export function formatReportingDateRange(since, until) {
    const formattedSince = formatReportingDate(since);
    const formattedUntil = formatReportingDate(until);

    if (formattedSince === null || formattedUntil === null) {
        return "—";
    }

    return `${formattedSince}–${formattedUntil}`;
}
